import { BoxModelConstraint, FreeFormTextComponent } from '@blk/simba';
import { DEFAULT_DISCLOSURE_TEXT_CLASSES } from '@ddt-web/pdf-utils';

export class DisclosureComponent extends FreeFormTextComponent {
	constructor(dcrKey: string, defaultText?: string, substitutions: {} = {}, constraints?: Partial<BoxModelConstraint>, textClasses?: string[]) {
		textClasses = textClasses ? textClasses : DEFAULT_DISCLOSURE_TEXT_CLASSES;
		super(dcrKey, defaultText, substitutions, constraints, textClasses);
	}
}
